<template>
  <BModal
    :model-value="show"
    centered
    size="sm"
    title="Confirm Delete"
    @hide="$emit('cancel')"
  >
    <p>Are you sure you want to delete this exemption?</p>
    <p class="text-muted mb-0">
      <strong>{{ target?.clinical_formulation_id }}</strong>
    </p>

    <template #footer>
      <BButton variant="secondary" @click="$emit('cancel')">Cancel</BButton>
      <BButton variant="danger" @click="$emit('confirm')" :disabled="loading">
        <BSpinner v-if="loading" small class="me-2" />
        Delete
      </BButton>
    </template>
  </BModal>
</template>

<script>
import { BModal, BButton, BSpinner } from 'bootstrap-vue-next';

export default {
  components: { BModal, BButton, BSpinner },
  props: {
    show: { type: Boolean, default: false },
    target: { type: Object, default: null },
    loading: { type: Boolean, default: false }
  }
};
</script>
